(() => {
  const validateForms = () => {
    document.querySelectorAll(".p4j-product-form").forEach((form) => {
      form.addEventListener("submit", (event) => {
        const required = form.querySelectorAll("[data-p4j-required]");
        for (const field of required) {
          if (!String(field.value || "").trim()) {
            event.preventDefault();
            field.focus();
            field.setAttribute("aria-invalid", "true");
            return;
          }
          field.removeAttribute("aria-invalid");
        }
      });
    });
  };

  const setupWishlist = () => {
    const storageKey = "p4j:wishlist";
    let saved = [];

    try {
      saved = JSON.parse(window.localStorage.getItem(storageKey) || "[]");
    } catch {
      saved = [];
    }

    const save = () => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(saved));
      } catch {
        // localStorage can be unavailable in private browsing.
      }
    };

    document.querySelectorAll("[data-p4j-wishlist]").forEach((button) => {
      const handle = button.getAttribute("data-product-handle");
      if (!handle) return;

      const update = () => {
        const isSaved = saved.includes(handle);
        button.setAttribute("aria-pressed", String(isSaved));
        button.setAttribute("title", isSaved ? "Saved" : "Save");
      };

      update();
      button.addEventListener("click", () => {
        if (saved.includes(handle)) {
          saved = saved.filter((item) => item !== handle);
        } else {
          saved = [...saved, handle];
        }
        save();
        update();
      });
    });
  };

  const setupProductPage = () => {
    document.querySelectorAll("[data-p4j-product]").forEach((productPage) => {
      const stickyPanel = productPage.querySelector(".p4j-product-info__sticky");
      const thumbs = Array.from(productPage.querySelectorAll("[data-p4j-gallery-thumb]"));
      const panels = Array.from(productPage.querySelectorAll("[data-p4j-gallery-panel]"));
      const stage = productPage.querySelector("[data-active-media-index]");
      const zoomButton = productPage.querySelector("[data-p4j-gallery-zoom]");
      const lightbox = productPage.querySelector("[data-p4j-lightbox]");
      const lightboxImage = productPage.querySelector("[data-p4j-lightbox-image]");
      const lightboxClose = productPage.querySelector("[data-p4j-lightbox-close]");
      let activeZoomSrc = thumbs[0]?.getAttribute("data-zoom-src") || "";
      let activeAlt = thumbs[0]?.getAttribute("data-alt") || "";

      const setActiveMedia = (index) => {
        thumbs.forEach((thumb) => {
          const isActive = thumb.getAttribute("data-media-index") === String(index);
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-current", String(isActive));
          if (isActive) {
            activeZoomSrc = thumb.getAttribute("data-zoom-src") || activeZoomSrc;
            activeAlt = thumb.getAttribute("data-alt") || activeAlt;
          }
        });

        panels.forEach((panel) => {
          const isActive = panel.getAttribute("data-media-index") === String(index);
          panel.classList.toggle("is-active", isActive);
          panel.setAttribute("aria-hidden", String(!isActive));
        });

        if (stage) stage.setAttribute("data-active-media-index", String(index));
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => {
          setActiveMedia(thumb.getAttribute("data-media-index"));
        });
      });

      if (zoomButton && lightbox && lightboxImage) {
        zoomButton.addEventListener("click", () => {
          if (!activeZoomSrc) return;
          lightboxImage.src = activeZoomSrc;
          lightboxImage.alt = activeAlt;
          if (typeof lightbox.showModal === "function") {
            lightbox.showModal();
          } else {
            window.open(activeZoomSrc, "_blank", "noopener");
          }
        });
      }

      if (lightboxClose && lightbox) {
        lightboxClose.addEventListener("click", () => lightbox.close());
      }

      const variantsScript = productPage.querySelector("[data-p4j-variants]");
      const optionInputs = Array.from(productPage.querySelectorAll("[data-p4j-option-value]"));
      const variantIdInput = productPage.querySelector("[data-p4j-variant-id]");
      const price = productPage.querySelector("[data-p4j-price]");
      const comparePrice = productPage.querySelector("[data-p4j-compare-price]");
      const addButton = productPage.querySelector("[data-p4j-add-button]");
      const addLabel = productPage.querySelector("[data-p4j-add-label]");
      let variants = [];

      const updateStickyState = () => {
        if (!stickyPanel) return;
        stickyPanel.classList.remove("is-sticky");
        if (window.innerWidth < 990) return;

        const availableHeight = window.innerHeight - 116;
        const fitsViewport = stickyPanel.scrollHeight <= availableHeight;
        stickyPanel.classList.toggle("is-sticky", fitsViewport);
      };

      try {
        variants = variantsScript ? JSON.parse(variantsScript.textContent || "[]") : [];
      } catch {
        variants = [];
      }

      const updateVariantDisplay = (variant) => {
        if (!variant) return;
        if (variantIdInput) variantIdInput.value = variant.id;
        if (price) price.textContent = variant.price;
        if (comparePrice) {
          comparePrice.textContent = variant.compareAtPrice || "";
          comparePrice.hidden = !variant.compareAtPrice;
        }
        if (addButton) addButton.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? "Add to cart" : "Sold out";
      };

      const updateVariantFromCurrentId = () => {
        if (!variants.length) return;
        const appVariantSelect = productPage.querySelector("#bcpo-select");
        const currentId = String(appVariantSelect?.value || variantIdInput?.value || "");
        const variant = variants.find((item) => String(item.id) === currentId);
        updateVariantDisplay(variant);
      };

      const normalizeVoProductOptions = () => {
        const appOptions = productPage.querySelector("#bcpo");
        if (!appOptions) return;

        const labelMap = {
          "back engraving": "Back engraving",
          plating: "Finish",
          "your pet's name (if you have chosen)": "Pet name or initials",
          "your custom message on the back (if you have chosen)": "Back engraving message",
          "your image": "Upload pet photo",
        };

        appOptions.querySelectorAll(".bcpo-title").forEach((title) => {
          const rawTitle = title.textContent.replace(/:/g, "").trim();
          const mappedTitle = labelMap[rawTitle.toLowerCase()];
          if (mappedTitle) title.textContent = mappedTitle;
        });

        const priceAddons = appOptions.querySelector(".bcpo-price-addons");
        if (priceAddons) {
          priceAddons.hidden = /(?:€|\$)?\s*0(?:[,.]00)?/.test(priceAddons.textContent || "");
        }

        const backEngravingSelect = appOptions.querySelector("#bcpo-select-option-0");
        const backMessageInput = Array.from(appOptions.querySelectorAll("input, textarea")).find((field) =>
          String(field.getAttribute("name") || "").includes("Custom Message on the back")
        );
        const backMessageWrapper = backMessageInput?.closest(".selector-wrapper");
        if (!backEngravingSelect || !backMessageWrapper || !backMessageInput) return;

        if (!backMessageInput.dataset.p4jWasRequired) {
          backMessageInput.dataset.p4jWasRequired = backMessageInput.required ? "true" : "false";
        }

        const needsBackMessage = String(backEngravingSelect.value || "")
          .toLowerCase()
          .includes("with back engraving");
        backMessageWrapper.hidden = !needsBackMessage;
        backMessageInput.required =
          needsBackMessage && backMessageInput.dataset.p4jWasRequired === "true";
      };

      const updateVariant = () => {
        if (!variants.length || !optionInputs.length) return;
        const selected = [];
        optionInputs.forEach((input) => {
          if (!input.checked) return;
          selected[Number(input.getAttribute("data-option-index"))] = input.value;

          const group = input.closest("[data-p4j-option-group]");
          const label = group?.querySelector("[data-p4j-selected-option]");
          if (label) label.textContent = input.value;
        });

        const variant = variants.find((item) =>
          item.options.every((option, index) => option === selected[index])
        );

        updateVariantDisplay(variant);
      };

      optionInputs.forEach((input) => input.addEventListener("change", updateVariant));
      productPage.addEventListener("change", (event) => {
        if (!(event.target instanceof Element)) return;
        if (!event.target.matches("#bcpo-select, [id^='bcpo-select-option']")) return;
        window.setTimeout(updateVariantFromCurrentId, 80);
        window.setTimeout(normalizeVoProductOptions, 90);
        window.setTimeout(updateStickyState, 120);
      });
      updateVariant();
      updateVariantFromCurrentId();
      normalizeVoProductOptions();
      updateStickyState();
      window.addEventListener("resize", updateStickyState, { passive: true });
      window.setTimeout(updateVariantFromCurrentId, 600);
      window.setTimeout(normalizeVoProductOptions, 600);
      window.setTimeout(normalizeVoProductOptions, 1600);
      window.setTimeout(updateStickyState, 600);
      window.setTimeout(updateStickyState, 1600);
      if ("ResizeObserver" in window && stickyPanel) {
        new ResizeObserver(updateStickyState).observe(stickyPanel);
      }
    });
  };

  const init = () => {
    validateForms();
    setupWishlist();
    setupProductPage();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();


(function(){function syncP4jThumbs(){document.querySelectorAll('.p4j-product-gallery').forEach(function(g){var t=g.querySelector('.p4j-product-gallery__thumbs'),s=g.querySelector('.p4j-product-gallery__stage');if(!t||!s)return;var cols=getComputedStyle(g).gridTemplateColumns.trim().split(' ').length;t.style.maxHeight=cols>=2?(s.offsetHeight+'px'):'';});}['load','resize','DOMContentLoaded'].forEach(function(e){window.addEventListener(e,syncP4jThumbs);});if('ResizeObserver'in window){var ro=new ResizeObserver(syncP4jThumbs);document.querySelectorAll('.p4j-product-gallery__stage').forEach(function(s){ro.observe(s);});}})();
